import React from "react";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import VisibilityIcon from "@material-ui/icons/Visibility";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";


export const PasswordCell = ({ value }) => {
  const [showPassword, setShowPassword] = React.useState(false);
  const handleTogglePassword = () => setShowPassword((showPassword) => !showPassword);
  return (
    <div>
      {showPassword ? value : null}
      <IconButton onClick={handleTogglePassword}>
        {showPassword ? (
          <Tooltip title="hide password">
            <VisibilityOffIcon />
          </Tooltip>
        ) : (
            <Tooltip title="show password">
              <VisibilityIcon />
            </Tooltip>
          )}
      </IconButton>
    </div>
  );
};
